import { render } from "./WCItemModifierInstructionsEntry.vue?vue&type=template&id=5ee9a3a0&scoped=true"
import script from "./WCItemModifierInstructionsEntry.vue?vue&type=script&lang=js"
export * from "./WCItemModifierInstructionsEntry.vue?vue&type=script&lang=js"

import "./WCItemModifierInstructionsEntry.vue?vue&type=style&index=0&id=5ee9a3a0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee9a3a0"]])

export default __exports__